import React, { useState } from 'react';
import { services } from '../../data/services';
import ServiceSection from '../../components/ServiceSection';
import Hero from '../../components/Hero';
import { MapPin } from 'lucide-react';

const Internet = () => {
  const [selectedZone, setSelectedZone] = useState('balti');
  const internetService = services.find(service => service.title === "Internet");

  const zones = [
    { id: 'balti', name: 'mun. Bălți' },
    { id: 'riscani', name: 'r-nul Râșcani' },
    { id: 'glodeni', name: 'r-nul Glodeni' },
    { id: 'falesti', name: 'r-nul Fălești' }
  ];

  const zonePricing = {
    balti: {
      Start: { price: "150", speed: "200" },
      Premium: { price: "200", speed: "300" },
      Pro: { price: "250", speed: "500" }
    },
    riscani: {
      Start: { price: "120", speed: "200" },
      Premium: { price: "160", speed: "300" },
      Pro: { price: "200", speed: "500" }
    },
    glodeni: {
      Start: { price: "120", speed: "200" },
      Premium: { price: "160", speed: "300" },
      Pro: { price: "200", speed: "500" }
    },
    falesti: {
      Start: { price: "170", speed: "200" },
      Premium: { price: "210", speed: "300" },
      Pro: { price: "250", speed: "500" }
    }
  };

  const getModifiedService = () => {
    if (!internetService) return null;

    const zonePackages = internetService.packages.map(pkg => {
      const zonePriceInfo = zonePricing[selectedZone][pkg.name as keyof typeof zonePricing.balti];
      return {
        ...pkg,
        price: zonePriceInfo.price,
        features: [
          `Viteză până la ${zonePriceInfo.speed} Mbps`,
          "Instalare Gratuită",
          "Router Wi-Fi inclus",
          "IP Static"
        ]
      };
    });

    return {
      ...internetService,
      packages: zonePackages
    };
  };

  const modifiedService = getModifiedService();

  const zoneSelector = (
    <div className="max-w-2xl mx-auto bg-secondary/40 p-6 rounded-xl mb-10">
      <div className="flex items-center justify-center mb-4">
        <MapPin className="h-6 w-6 text-primary mr-2" />
        <h2 className="text-xl text-primary font-heading font-semibold">Selectează Zona Ta</h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {zones.map(zone => (
          <button
            key={zone.id}
            onClick={() => setSelectedZone(zone.id)}
            className={`px-6 py-3 rounded-lg transition-all duration-300 transform hover:scale-105 ${
              selectedZone === zone.id
                ? 'bg-accent-500 text-white shadow-lg'
                : 'bg-white text-primary hover:bg-secondary'
            }`}
          >
            {zone.name}
          </button>
        ))}
      </div>
    </div>
  );

  return (
    <>
      <Hero
        title="Internet de Mare Viteză"
        subtitle="Conectivitate stabilă și rapidă prin fibră optică pentru casa ta"
        variant="compact"
        ctaLabel="Vezi Tarife"
        ctaHref="#tarife"
        backgroundImageUrl="/img/hero-internet.jpg"
        icon={internetService?.icon}
        iconLabel={internetService?.title}
      />

      {modifiedService && (
        <ServiceSection
          service={modifiedService}
          index={0}
          pricingFirst
          id="tarife"
          beforePackages={zoneSelector}
          backgroundImage={false}
          showTitleBlock={false}
        />
      )}
    </>
  );
};

export default Internet;
